import { Button, InputBase } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 257,
    borderRadius: 13,
    backgroundColor: "#39d5cf",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    marginTop: 36,
    marginBottom: 51,
  },
  searchField: {
    width: 620,
    height: 50,
    borderRadius: 7,
    padding: 8,
    backgroundColor: "white",
    textAlign: "center",
    align: "center",
    "& input": {
      textAlign: "center",
      "&::-webkit-input-placeholder": { color: "#5f5f5f" },
    },
  },
  searchButton: {
    width: 190,
    backgroundColor: "#1ba7a1",
    color: "white",
    "&:hover": {
      backgroundColor: "#1ba7a1",
    },
  },
  cancleButton: {
    width: 190,
    marginLeft: 20,
    backgroundColor: "white",
  },
  flexRow: {
    marginTop: 41,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  searchIcon: {
    color: "white",
    opacity: 0.3,
    fontSize: 357,
    position: "absolute",
    left: -70,
    top: 1,
  },
}));

export default function SearchFilterBox({
  searchValue,
  onSearch,
  onClickSearch,
  onClickCancel,
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <InputBase
        className={classes.searchField}
        placeholder="Keywords..."
        onChange={onSearch}
        value={searchValue}
      />
      <div className={classes.flexRow}>
        <Button
          variant="contained"
          size="large"
          className={classes.searchButton}
          onClick={onClickSearch}
        >
          Search
        </Button>
        <Button
          variant="contained"
          size="large"
          className={classes.cancleButton}
          onClick={onClickCancel}
        >
          Cancel
        </Button>
      </div>
      <SearchIcon className={classes.searchIcon} />
    </div>
  );
}
